import { render } from "./TablaColectivosFamilias.vue?vue&type=template&id=233e16a5&ts=true"
import script from "./TablaColectivosFamilias.vue?vue&type=script&lang=ts"
export * from "./TablaColectivosFamilias.vue?vue&type=script&lang=ts"

import "./TablaColectivosFamilias.vue?vue&type=style&index=0&id=233e16a5&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__